import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter as Router, Route, Routes, Navigate, useParams } from "react-router-dom";
import 'rsuite/dist/rsuite.min.css';
import { CustomProvider } from 'rsuite';

import { Home, CardSearch, CardView, SetSearch, SetView, Login, Register, ForgotPassword, ResetPassword, CollectionsDashboard, CollectionDetail, GrandCollection, SharedCollectionView, RulesReference, RulesSection, KeywordGlossary, LayersReference, StackReference, CombatReference, SBAReference, TurnStructure, ZonesReference, Settings, ProtectedRoute, Footer, Legal, PrivacyPolicy, TermsOfService, AccountRecreationWarning } from './components';
import { AuthProvider } from './components/Auth/AuthContext';
import SetUsernameModal from './components/Auth/SetUsernameModal';
import { PreferencesProvider } from './components/Preferences/PreferencesContext';
import { usePreferences } from './components/Preferences/PreferencesContext';
import PlaytestPage from './components/Playtest/PlaytestPage';
import { PlaytestSessionProvider } from './components/Playtest/PlaytestSessionProvider';

const RedirectCollectionId = () => {
  const { id } = useParams();
  return <Navigate to={`/library/${id}`} replace />;
};

const ThemeWrapper = ({ children }) => {
  const { preferences } = usePreferences();
  return <CustomProvider theme={preferences.theme}>{children}</CustomProvider>;
};

const AppShell = ({ children }) => (
  <PreferencesProvider>
    <ThemeWrapper>
      <AccountRecreationWarning />
      <SetUsernameModal />
      {children}
    </ThemeWrapper>
  </PreferencesProvider>
);

ReactDOM.render(
  <Router>
    <AuthProvider>
      <PlaytestSessionProvider>
        <AppShell>
          <div style={{ display: 'flex', flexDirection: 'column', minHeight: '100vh' }}>
            <div style={{ flex: 1 }}>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/cardsearch" element={<CardSearch />} />
                <Route path="/cardsearch/:id" element={<CardView />} />
                <Route path="/setsearch" element={<SetSearch />} />
                <Route path="/set/:id" element={<SetView />} />
                <Route path="/library" element={<ProtectedRoute><CollectionsDashboard /></ProtectedRoute>} />
                <Route path="/collection" element={<ProtectedRoute><GrandCollection /></ProtectedRoute>} />
                <Route path="/library/:id" element={<ProtectedRoute><CollectionDetail /></ProtectedRoute>} />
                <Route path="/library/:id/playtest" element={<ProtectedRoute><PlaytestPage /></ProtectedRoute>} />
                <Route path="/collections" element={<Navigate to="/library" replace />} />
                <Route path="/collections/grand" element={<Navigate to="/collection" replace />} />
                <Route path="/collections/:id" element={<RedirectCollectionId />} />
                <Route path="/rules" element={<RulesReference />} />
                <Route path="/rules/keywords" element={<KeywordGlossary />} />
                <Route path="/rules/layers" element={<LayersReference />} />
                <Route path="/rules/stack-and-priority" element={<StackReference />} />
                <Route path="/rules/combat" element={<CombatReference />} />
                <Route path="/rules/state-based-actions" element={<SBAReference />} />
                <Route path="/rules/turn-structure" element={<TurnStructure />} />
                <Route path="/rules/zones" element={<ZonesReference />} />
                <Route path="/rules/:sectionId" element={<RulesSection />} />
                <Route path="/legal" element={<Legal />} />
                <Route path="/privacy" element={<PrivacyPolicy />} />
                <Route path="/terms" element={<TermsOfService />} />
                <Route path="/settings" element={<Settings />} />
                <Route path="/shared/:slug" element={<SharedCollectionView />} />
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
              </Routes>
            </div>
            <Footer />
          </div>
        </AppShell>
      </PlaytestSessionProvider>
    </AuthProvider>
  </Router>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
